var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"spinner-border spinner-border-sm mr-2",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(_vm._s(_vm.showText ? 'Loading...' : null)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }